import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { menuItens } from '../../store/actions';

const Navdata = () => {
  const dispatch = useDispatch();
  const [menu, setMenu] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  const { itens, error } = useSelector((state) => ({
    itens: state.Menu.itens,
    error: state.Menu.error,
  }));

  const createMenuLayout = useCallback(
    (item) => {
      let layout = [];

      if (item) {
        (item.childItems || item.subItems).map((item) => {
          return (layout = [
            ...layout,
            {
              ...item,
              id: item.id,
              label: item.label,
              link: item.link || '/#',
              parent_id: item.id,
              childItems: item.childItems ? createMenuLayout(item) : null,
              stateVariables: menu[item.id],
              isOpen: false,
              click: function (e) {
                e.preventDefault();
                setMenu({
                  ...menu,
                  [item.id]: !menu[item.id],
                });
                updateIconSidebar(e);
              },
            },
          ]);
        });
        return layout;
      }

      itens.map((item) => {
        return (layout = [
          ...layout,
          {
            id: item.id,
            label: item.label,
            icon: item.icon,
            link: item.link || '/#',
            isOpen: false,
            stateVariables: menu[item.id],
            subItems: item.subItems ? createMenuLayout(item) : null,
            click: function (e) {
              e.preventDefault();
              setMenu({
                ...menu,
                [item.id]: !menu[item.id],
              });
              updateIconSidebar(e);
            },
          },
        ]);
      });

      return layout;
    },
    [itens, menu]
  );

  const createDataMenu = useCallback(() => {
    let data = {};

    itens.map((item) => {
      return (data = {
        ...data,
        [item.stateVariables]: false,
      });
    });

    setMenu(data);
  }, [itens]);

  useEffect(() => {
    createDataMenu();
  }, [createDataMenu, itens]);

  useEffect(() => {
    setMenuItems(createMenuLayout());
  }, [createMenuLayout, menu]);

  useEffect(() => {
    dispatch(menuItens());
  }, [dispatch]);

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute('subitems')) {
      const ul = document.getElementById('two-column-menu');
      const iconItems = ul.querySelectorAll('.nav-icon.active');
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove('active');
        var id = item.getAttribute('subitems');
        if (document.getElementById(id))
          document.getElementById(id).classList.remove('show');
      });
    }
  }

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
